<template>
<div style="width:100%;height:60.375rem;overflow:hidden;background-color: rgb(240,242,245)">
  <div class="login_big_box">
     <img src="../../assets/image/login2/loginWeiTu1.png" class="login_one_photo"/>
    <img src="../../assets/image/login2/loginWeiTu2.png" class="login_tow_photo">
    <img src="../../assets/image/login2/loginWeiTu3.png" class="login_three_photo"/>
    <div class="login_insize_box">
         <div>
           <el-tabs v-model="activeName" @tab-click="handleClick">
             <el-tab-pane label="账号密码登录" name="first"></el-tab-pane>
             <el-tab-pane label="注册账号" name="second"></el-tab-pane>
           </el-tabs>
         </div>
<!--      <el-form-->
<!--        ref="login"-->
<!--        :rules="rules"-->
<!--        :model="form"-->
<!--        label-width="0"-->
<!--        style="width:100%;"-->
<!--        @keydown.enter.native="submit"-->
<!--      >-->
<!--        <el-form-item prop="userID">-->
<!--          <el-input v-model="form.userID" placeholder="请输入用户名" type="text" clearable></el-input>-->
<!--        </el-form-item>-->
<!--        <el-form-item prop="password">-->
<!--          <el-input-->
<!--            v-model="form.password"-->
<!--            placeholder="请输入密码"-->
<!--            type="password"-->
<!--            show-password-->
<!--            clearable-->
<!--          ></el-input>-->
<!--        </el-form-item>-->
<!--      </el-form>-->
    </div>
  </div>
</div>
</template>

<script>

export default {
 name: "login",

 data(){

   return {
     activeName: 'first',
     // form: {
     //   userID: 'user0',
     //   password: ''
     // },
     // rules: {
     //   userID: [
     //     {required: true, message: '请输入 userID', trigger: 'blur'},
     //     {validator: checkUserID, trigger: 'blur'}
     //   ],
     //   password: [{required: true, message: '请输入密码', trigger: 'blur'}]
     // },
   }
 } ,
  methods:{
    handleClick(tab, event) {
      console.log(tab, event);
    },
  }
}
</script>

<style  scoped>
.login_big_box{
  width: 90rem;
  height: 46.8rem;
  margin: 5% auto;
  box-shadow: darkgrey 0px 0px 30px 5px;
  background-color: rgb(240,242,245);
  position: relative;
}
.login_one_photo{
  width: 9.2rem;
  height: 8.5rem;
  display: block;
  padding-top: 4.9rem;
  padding-left: 5.6rem;
}
.login_tow_photo{
  width: 6.125rem;
  height: 5.625rem;
  padding-top: 23rem;
  padding-left: 8.625rem;
}
.login_three_photo{
  width: 21.2rem;
  height: 17.3rem;
  display: block;
  padding-left: 68.5rem;
  margin-top: -12.8rem;
}
.login_insize_box{
  width: 25rem;
  height: 20rem;
  background-color: #ea8dac;
  position: absolute;
  top: 27%;
  left: 34%;
}
/*修改tab字体大小*/
.el-tabs__item {
  font-size: 1rem;
}
/*去掉标签页下划线*/
.el-tabs__nav-wrap::after {
  background-color: transparent;
}
.el-tabs__active-bar {
  bottom: 0.38rem;
}
</style>



// WEBPACK FOOTER //
// src/components/loginAndReg/login2.vue